import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center my-2"
};
const _hoisted_2 = {
    class: "inline-flex items-center px-4 text-xs text-white rounded-2xl",
    style: { "height": "28px", "background-color": "#e8472a" }
};
const _hoisted_3 = ["data-direction"];
const _hoisted_4 = {
    key: 0,
    class: "flex items-end gap-2.5 max-w-[75%]"
};
const _hoisted_5 = { class: "space-y-1" };
const _hoisted_6 = {
    key: 0,
    class: "text-sm"
};
const _hoisted_7 = { key: 1 };
const _hoisted_8 = {
    class: "flex items-center gap-1.5 px-1 justify-start",
    "data-test": "message-meta"
};
const _hoisted_9 = { class: "text-[10px] text-[#9CA3AF]" };
const _hoisted_10 = { class: "text-[10px] text-[#9CA3AF]" };
const _hoisted_11 = {
    key: 0,
    class: "text-[10px] text-[#9CA3AF]"
};
const _hoisted_12 = {
    key: 1,
    class: "max-w-[75%] space-y-1"
};
const _hoisted_13 = {
    key: 0,
    class: "text-sm"
};
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { class: "relative" };
const _hoisted_16 = {
    key: 0,
    class: "flex gap-2 mt-1"
};
const _hoisted_17 = ["onKeydown"];
const _hoisted_18 = {
    class: "flex items-center gap-1.5 px-1 justify-end",
    "data-test": "message-meta"
};
const _hoisted_19 = { class: "text-[10px] text-white opacity-75" };
const _hoisted_20 = { class: "text-[10px] text-white opacity-75" };
const _hoisted_21 = {
    key: 0,
    class: "text-[10px] text-white opacity-75"
};
import { ref, computed } from "vue";
import { IconDotsVertical, IconEdit, IconTrash, } from "@tabler/icons-vue";
import { conversationService } from "../services/conversation.service";
import MessageAttachmentPreview from "./MessageAttachmentPreview.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'MessageBubble',
    props: {
        message: {},
        currentUserId: {},
        currentOrgId: {}
    },
    emits: ["edit", "delete"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const menuOpen = ref(false);
        const editing = ref(false);
        const editText = ref("");
        const isHovered = ref(false);
        let leaveTimer = null;
        function onEnter() {
            if (leaveTimer) {
                clearTimeout(leaveTimer);
                leaveTimer = null;
            }
            isHovered.value = true;
        }
        function onLeave() {
            leaveTimer = setTimeout(() => {
                isHovered.value = false;
            }, 200);
        }
        const normalizeId = (value) => value == null || value === "" ? null : String(value);
        const isOwnOrg = computed(() => normalizeId(props.message.sender_org_id) !== null &&
            normalizeId(props.message.sender_org_id) === normalizeId(props.currentOrgId));
        const canMutateMessage = computed(() => isOwnOrg.value &&
            normalizeId(props.message.sender_id) === normalizeId(props.currentUserId));
        const senderLabel = computed(() => {
            const sender = props.message.sender;
            return (sender?.display_name?.trim() ||
                sender?.name?.trim() ||
                props.message.sender_org_name?.trim() ||
                "Usuario");
        });
        const senderInitials = computed(() => conversationService.getInitials(senderLabel.value));
        const senderAvatarColor = computed(() => conversationService.getAvatarColor(props.message.sender_org_id ?? props.message.sender_id ?? props.message.id));
        const formattedTime = computed(() => {
            const date = new Date(props.message.created_at);
            return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
        });
        function startEdit() {
            editText.value = props.message.message ?? "";
            editing.value = true;
            menuOpen.value = false;
        }
        function cancelEdit() {
            editing.value = false;
            editText.value = "";
        }
        function submitEdit() {
            if (!editText.value.trim())
                return;
            emit("edit", props.message.id, editText.value.trim());
            editing.value = false;
        }
        function handleDelete() {
            emit("delete", props.message.id);
            menuOpen.value = false;
        }
        const vClickOutside = {
            mounted(el, binding) {
                el._clickOutsideHandler = (event) => {
                    if (!el.contains(event.target)) {
                        binding.value();
                    }
                };
                document.addEventListener("click", el._clickOutsideHandler);
            },
            unmounted(el) {
                document.removeEventListener("click", el._clickOutsideHandler);
            },
        };
        return (_ctx, _cache) => {
            return (__props.message.message_type === 'SYSTEM')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(__props.message.message), 1)
                ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["flex", isOwnOrg.value ? 'justify-end' : 'justify-start']),
                    "data-test": "message-row",
                    "data-direction": isOwnOrg.value ? 'outgoing' : 'incoming'
                }, [
                    (!isOwnOrg.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", {
                                class: "flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-full text-white text-[11px] font-bold",
                                style: _normalizeStyle({ backgroundColor: senderAvatarColor.value })
                            }, _toDisplayString(senderInitials.value), 5),
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["relative group px-4 py-2.5 text-sm break-words", [
                                            'rounded-tl-xl rounded-tr-xl rounded-bl-sm rounded-br-xl',
                                            'bg-white text-gray-900',
                                            __props.message.deleted_at ? 'italic opacity-60' : '',
                                        ]]),
                                    style: { "box-shadow": "0 1px 2px rgba(0, 0, 0, 0.08)" }
                                }, [
                                    (__props.message.deleted_at)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("conversation.auto.este_mensaje_fue_eliminado")), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.message.message), 1)),
                                    (!__props.message.deleted_at && __props.message.attachment_url)
                                        ? (_openBlock(), _createBlock(MessageAttachmentPreview, {
                                            key: 2,
                                            url: __props.message.attachment_url,
                                            name: __props.message.attachment_name,
                                            "mime-type": __props.message.attachment_mime_type,
                                            size: __props.message.attachment_size
                                        }, null, 8, ["url", "name", "mime-type", "size"]))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(formattedTime.value), 1),
                                    _createElementVNode("span", _hoisted_10, "· Enviado por " + _toDisplayString(senderLabel.value), 1),
                                    (__props.message.edited_at && !__props.message.deleted_at)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t("conversation.auto.editado")), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", {
                                class: _normalizeClass(["relative px-4 py-2.5 text-sm break-words", [
                                        'rounded-tl-xl rounded-tr-xl rounded-bl-xl rounded-br-sm',
                                        'text-white',
                                        __props.message.deleted_at ? 'italic opacity-60' : '',
                                    ]]),
                                style: { "background-color": "#e8472a" },
                                onMouseenter: onEnter,
                                onMouseleave: onLeave
                            }, [
                                (__props.message.deleted_at)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("conversation.auto.este_mensaje_fue_eliminado")), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(__props.message.message), 1)),
                                (!__props.message.deleted_at && __props.message.attachment_url)
                                    ? (_openBlock(), _createBlock(MessageAttachmentPreview, {
                                        key: 2,
                                        url: __props.message.attachment_url,
                                        name: __props.message.attachment_name,
                                        "mime-type": __props.message.attachment_mime_type,
                                        size: __props.message.attachment_size,
                                        "is-outgoing": ""
                                    }, null, 8, ["url", "name", "mime-type", "size"]))
                                    : _createCommentVNode("", true),
                                (canMutateMessage.value && !__props.message.deleted_at)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 3,
                                        class: _normalizeClass(["absolute -left-8 top-1", (isHovered.value || menuOpen.value) ? 'flex' : 'hidden']),
                                        onMouseenter: onEnter,
                                        onMouseleave: onLeave
                                    }, [
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("button", {
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (menuOpen.value = !menuOpen.value), ["stop"])),
                                                class: "p-1 text-gray-400 rounded-full hover:bg-gray-200 hover:text-gray-600",
                                                "data-test": "message-actions-trigger"
                                            }, [
                                                _createVNode(_unref(IconDotsVertical), { class: "w-4 h-4" })
                                            ]),
                                            (menuOpen.value)
                                                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: "absolute right-0 z-10 w-32 overflow-hidden bg-white border border-gray-200 rounded-lg shadow-lg top-full mt-1",
                                                    onMouseenter: onEnter,
                                                    onMouseleave: onLeave
                                                }, [
                                                    _createElementVNode("button", {
                                                        onClick: startEdit,
                                                        class: "flex items-center w-full gap-2 px-3 py-2 text-sm text-left text-gray-700 hover:bg-gray-50"
                                                    }, [
                                                        _createVNode(_unref(IconEdit), { class: "w-4 h-4" }),
                                                        _createTextVNode(_toDisplayString(_ctx.$t("conversation.auto.editar")), 1)
                                                    ]),
                                                    _createElementVNode("button", {
                                                        onClick: handleDelete,
                                                        class: "flex items-center w-full gap-2 px-3 py-2 text-sm text-left text-red-600 hover:bg-red-50"
                                                    }, [
                                                        _createVNode(_unref(IconTrash), { class: "w-4 h-4" }),
                                                        _createTextVNode(_toDisplayString(_ctx.$t("conversation.auto.eliminar")), 1)
                                                    ])
                                                ], 32)), [
                                                    [vClickOutside, () => (menuOpen.value = false)]
                                                ])
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 34))
                                    : _createCommentVNode("", true)
                            ], 34),
                            (editing.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editText).value = $event)),
                                        onKeydown: [
                                            _withKeys(_withModifiers(submitEdit, ["prevent"]), ["enter"]),
                                            _withKeys(cancelEdit, ["escape"])
                                        ],
                                        class: "flex-1 px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-eorange-400",
                                        autofocus: ""
                                    }, null, 40, _hoisted_17), [
                                        [_vModelText, editText.value]
                                    ]),
                                    _createElementVNode("button", {
                                        onClick: submitEdit,
                                        class: "px-3 py-1.5 text-xs bg-eorange-400 text-white rounded-lg hover:bg-eorange-500"
                                    }, _toDisplayString(_ctx.$t("conversation.auto.guardar")), 1),
                                    _createElementVNode("button", {
                                        onClick: cancelEdit,
                                        class: "px-3 py-1.5 text-xs border border-gray-200 text-gray-500 rounded-lg hover:bg-gray-50"
                                    }, _toDisplayString(_ctx.$t("conversation.auto.cancelar")), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(formattedTime.value), 1),
                                _createElementVNode("span", _hoisted_20, "· Enviado por " + _toDisplayString(senderLabel.value), 1),
                                (__props.message.edited_at && !__props.message.deleted_at)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("conversation.auto.editado")), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                ], 10, _hoisted_3));
        };
    }
});
